export default __webpack_public_path__ + "static/media/anuncie.e5604629.jpg";